import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class IntelligentDataColumn extends Component {
  render() {
    const {
      item,
      handleVisibleAllMajor,
      handleVisibleMajor,
      handleVisibleSchoolDetail,
    } = this.props;
    return (
      <div className="intelligentDataColumn_box">
        <div className="intelligentDataColumn_school_box">
          <div style={{ height: 35, width: 5 }} className="fl"></div>
          <div className="fl">{item.school_code}</div>
          <div onClick={() => handleVisibleSchoolDetail(item.a_hash_id)}>
            <div className="fl major_left_15">{item.school_name}</div>
            <div className="fl">
              <img
                alt=""
                src={require("../../../../../images/intelligent/school_triangle.png")}
              ></img>
            </div>
          </div>

          <div
            onClick={() => handleVisibleAllMajor(item.i_hash_id)}
            className="fr intelligentDataColumn_school_more_box"
          >
            更多
          </div>
          <div className="clear"></div>
        </div>
        <table className="intelligentDataColumn_major_table_box">
          <tbody>
            {item.intelligent_school_majors.map((major, index) => {
              return (
                <tr key={index}>
                  <td
                    style={{
                      borderLeft: 0,
                      width: "42%",
                      textAlign: "left",
                      paddingLeft: "5px",
                    }}
                  >
                    {major.major_name}
                  </td>
                  <td style={{ width: "10%" }}>{major.plan_num}</td>
                  {major.school_year > 4 ? (
                    <td
                      style={{
                        width: "5%",
                        color: "#d80000",
                        fontWeight: "bold",
                      }}
                    >
                      {major.school_year}
                    </td>
                  ) : (
                    <td style={{ width: "5%" }}>{major.school_year}</td>
                  )}
                  <td style={{ width: "10%" }}>{major.level}</td>
                  <td style={{ width: "10%" }}>{major.score}</td>
                  <td
                    onClick={() => handleVisibleMajor(major.major_hash_id)}
                    style={{ borderRight: 0, width: "23%" }}
                  >
                    {major.rank}
                    <img
                      className="fr"
                      alt=""
                      src={require("../../../../../images/intelligent/detail.png")}
                    ></img>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default IntelligentDataColumn;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentDataColumn/index.js